import {createContext, useState} from "react";

export const ClientContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyClient = {
        id: "",
        clientId: "",
        name: "",
        enabled: true,
        realmType: null,
        description: "",
        serviceAccountEnabled: false,
        startDate: null,
        endDate: null,
        redirectUris: [],
        webOrigins: []
    }

    const [client, setClient] = useState(emptyClient);
    const [clients, setClients] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [clientDialog, setClientDialog] = useState(false);

    const resetClient = () => {
        setClient(emptyClient);
    };

    // Make the context object:
    const clientContext = {
        client,
        resetClient,
        setClient,
        clients,
        setClients,
        submitted,
        setSubmitted,
        clientDialog,
        setClientDialog,
    };

    // pass the value in provider and return
    return <ClientContext.Provider value={clientContext}>{children}</ClientContext.Provider>;
}

export const {Consumer} = ClientContext;
